//检测歌手名是否合法
export async function checkName(word) {
  if(!word.trim()) return true
  //表情 特殊符号
  let iconRule1 = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】；‘’，。]/im
  let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
  if (iconRule1.test(word) || iconRule2.test(word)) {
    window.eventEmitter.emit('toast', '请不要输入特殊字符')
    return false
  }
  //敏感词
  let res = ''
  try {
    res = await window.api({
      apiName: 'sensitive',
      postData: {
        word: word
      }
    })
  } catch (error) {
    window.eventEmitter.emit('toast', error || '服务器异常')
  }
  if(res.data.data.resultInfo) {
    window.eventEmitter.emit('toast', res.data.data.resultInfo)
    return false
  }
  return true
}
export async function checkSongName(word) {
  if(!word.trim()) return true
  //表情 特殊符号,songName不限制小括号和英文-和下划线，顿号; 空格-空格拦截
  let iconRule1 = /[`~!@#$%^&*+=<>?:{}|,.\/;\\[\]·~！@#￥%……&*+={}|《》？：“”【】；‘’，。]/im
  let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
  let iconRule3 = /\s-\s/ig
  if (iconRule1.test(word) || iconRule2.test(word) || iconRule3.test(word)) {
    window.eventEmitter.emit('toast', '请不要输入特殊字符')
    return false
  }
  //敏感词
  let res = ''
  try {
    res = await window.api({
      apiName: 'sensitive',
      postData: {
        word: word
      }
    })
  } catch (error) {
    window.eventEmitter.emit('toast', error || '服务器异常')
  }
  if(res.data.data.resultInfo) {
    window.eventEmitter.emit('toast', res.data.data.resultInfo)
    return false
  }
  return true
}
//检测简介是否合法
export async function checkIntro(word) {
  //字数
  if (word.length < 10 || word.length > 2000) {
    window.eventEmitter.emit('toast', '简介请输入10-2000字')
    return false
  }
  //表情
  let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
  if (iconRule2.test(word)) {
    window.eventEmitter.emit('toast', '请不要输入特殊字符')
    return false
  }
  //敏感词
  let res = ''
  try {
    res = await window.api({
      apiName: 'sensitive',
      postData: {
        word: word
      }
    })
  } catch (error) {
    window.eventEmitter.emit('toast', error.error || '服务器异常')
  }
  if(res.data.data.resultInfo) {
    window.eventEmitter.emit('toast', res.data.data.resultInfo)
    return false
  }
  return true
}


// WEBPACK FOOTER //
// ./src/lib/sensitive.js